import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Api from "../../api/api";

const UpdateStatus = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    status: "1",
    image: null,
  });

  useEffect(() => {
    if (location.state) {
      const statusStr = location.state.status === 1 || location.state.status === "1" ? "1" : "0";
      setFormData({
        title: location.state.title || "",
        status: statusStr,
        image: null,
      });
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData((prev) => ({ ...prev, image: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const data = new FormData();
      data.append("title", formData.title.trim());
      data.append("status", formData.status);

      if (formData.image) {
        data.append("image", formData.image);
      }

      const token = localStorage.getItem("access_token");
      await Api.updateBanner(id, data, token);

      Swal.fire("Success", "Updated successfully!", "success");
      navigate("/user-banner", { state: { refresh: true } });
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      Swal.fire("Error", error.response?.data?.message || "Failed to update banner.", "error");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "2rem",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "500px",
          padding: "2rem",
          border: "1px solid #ccc",
          borderRadius: "10px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2 data-id="Update-Banner" style={{ marginBottom: "1.5rem", textAlign: "center", color: "#333" }}>
          Update Banner
        </h2>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <div>
            <label
              data-id="Title"
              htmlFor="title">Title</label>
            <input
              id="title"
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "1rem",
              }}
            />
          </div>

          <div>
            <label
              data-id="Image"
              htmlFor="image">Image</label>
            <input
              id="image"
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "1rem",
              }}
            />
          </div>

          <div>
            <label
              data-id="Status"
              htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "1rem",
              }}
            >
              <option value="1">Active</option>
              <option value="0"> Inactive</option>
            </select>
          </div>

          <button
            type="submit"
            style={{
              padding: "12px 20px",
              borderRadius: "8px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            Update Banner
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateStatus;
